import { IPlacingTermsSelected } from '../../../browser/addform/types';

export const replaceHighlightWithColor = (str: string) => str.replace('highlight', 'color');

export const getAnalyticsVariant = (selected: IPlacingTermsSelected | null) => {
  if (!selected || !selected.option.id) {
    return undefined;
  }

  const { option, additionals } = selected;

  const optionIds = replaceHighlightWithColor(option.id).split('+');

  const additionalIds = additionals
    .filter(additionalOption => additionalOption.id)
    .map(({ id }) => replaceHighlightWithColor(id));

  return [...optionIds, ...additionalIds].join('/');
};
